export default "__VITE_ASSET__DVvbJ7hH__"